import { useMemo } from "react";

import { chargerCoordinates } from "../Map/ChargerCoordinates";
import "./SummaryMapTile.css";

function SummaryMapTile({
  locations = [],
  selectedLocations = [],
  chargerType = "Both",
  onViewMap
}) {
  // Retrieves the map locations for each charger type
  const mappedLocations = useMemo(() => {
    const allowedLocations = locations.filter((location) => {
      if (chargerType === "Both") {
        return true;
      }

      return location.type === chargerType;
    });

    const selected =
      selectedLocations.length === 0
        ? allowedLocations
        : allowedLocations.filter((location) =>
            selectedLocations.includes(
              location.chargingStationId
            )
          );

    return selected.filter(
      (location) =>
        chargerCoordinates[location.locationName]
    );
  }, [
    locations,
    selectedLocations,
    chargerType
  ]);

  return (
    <div className="summary-map-tile">
      <div className="summary-map-preview">
        <span className="summary-map-label">
          Charger locations
        </span>

        <strong>
          {mappedLocations.length}{" "}
          {mappedLocations.length === 1
            ? "location"
            : "locations"}
        </strong>

        <p>
          View the mapped charger locations matching the current
          filters.
        </p>

        <button
          type="button"
          className="summary-map-button"
          onClick={onViewMap}
          disabled={mappedLocations.length === 0}
        >
          View locations on map →
        </button>
      </div>
    </div>
  );
}

export default SummaryMapTile;